import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

/**
 * Conveys if something is {@link Quality.Good good}, {@link Quality.Bad bad},
 * or {@link Quality.Neutral neutral}
 */
export enum Quality {
  Good = 'good',
  Neutral = 'neutral',
  Bad = 'bad',
}
// Needs to be before namespace is defined
const QUALITIES: ReadonlySet<Quality> = new Set(
  Object.values(Quality) as Quality[],
)
export namespace Quality {
  export const ALL: readonly Quality[] = Array.from(QUALITIES)
  export const isQuality = TypeChecker.Factory.oneOf(QUALITIES)
  export const assertIsQuality: TypeAsserter<Quality> =
    TypeAsserter.Factory.from(isQuality)
}
